import Axios from "axios";

const state = {
  //number of page resulting of the pagination of observations resulting a query
  numberOfPage: null,
  //number of observation per page
  pageSize: 10
};

const getters = {
  getNumberOfPage: state => {
    return state.numberOfPage;
  },
  getPageSize: state => {
    return state.pageSize;
  }
};

const mutations = {
  UPDATE_NUMBER_OF_PAGE: (state, payload) => {
    state.numberOfPage = payload;
  },
  UPDATE_PAGE_SIZE: (state, payload) => {
    state.pageSize = payload;
  }
};

const actions = {
  /**
   * Calculate the number of page resulting of the pagination of observations resulting a query
   */
  setNumberOfPage: store => {
    if (store.rootGetters.getObservationsCount % state.pageLength !== 0) {
      store.commit(
        "UPDATE_NUMBER_OF_PAGE",
        Math.floor(store.rootGetters.getObservationsCount / state.pageSize) +1
      );
    } else {
    store.commit(
      "UPDATE_NUMBER_OF_PAGE",
      Math.floor(
        store.rootGetters.getObservationsCount / store.getters.getPageSize
      )
    );
    }
  },
  /**
   * Change the number of observations diplayed on one page
   */
  changePageSize: (store, { filters, pageSize}) => {
    store.commit("UPDATE_PAGE_SIZE", pageSize);
    store.dispatch("changePage", { filters, pageSize, pageSelected: 1 });
    store.dispatch("setNumberOfPage");
  },
  /**
   * Query the given page of the pagination.
   */
  changePage: (store, { filters, pageSize, pageSelected }) => {
    let headers = {
      "Content-Type": "application/json"
    };
    Axios.post(
      "/trajectories/observation/changeObservationsPage",
      { filters, pageSize, pageSelected },
      {
        headers: headers
      }
    ).then(response => {
      store.commit("UPDATE_OBSERVATIONS", response.data.content);
    });
  }
};

export let pages = {
  state,
  getters,
  mutations,
  actions
};
